import * as PropTypes from 'prop-types';
import * as React from 'react';
import BrandAvatar from './BrandAvatar';
import Button from './Button';

const SessionExpiredPage = ({ title, text, buttonLabel, onClick }) => (
  <div className="flex flex-col items-center justify-center h-screen">
    <BrandAvatar size="16" />
    <h1 className="mt-6 text-2xl">{title}</h1>
    <p className="mt-2">{text}</p>
    <Button kind="primary" className="mt-8" onClick={onClick}>
      {buttonLabel}
    </Button>
  </div>
);

SessionExpiredPage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SessionExpiredPage;
